module.exports = __webpack_public_path__ + "img/animated-screen-2.046cac38.svg";